import { SelectItem } from 'primeng/api';
import { TranslationService } from '../../translation/translation.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'wl-page-size-dropdown',
  templateUrl: './page-size-dropdown.component.html',
  styleUrls: ['./page-size-dropdown.component.less'],
  standalone: false
})
export class PageSizeDropdownComponent implements OnInit {
  @Input() pageSizes: number[];

  @Input()
  public get pageSize() {
    return this.selectedPageSize;
  }
  public set pageSize(value: number) {
    // this will trigger simply by having the page size items array populated. If selectedPageSize is being initially set, we don't want this to be called. So we're checking it beforehand.
    let initComplete = !!this.selectedPageSize;
    if (value !== this.selectedPageSize) {
      if (this.selectedPageSize == null) {
        setTimeout(() => {
          this.selectedPageSize = value;
          if (initComplete) {
            this.pageSizeChange.emit(this.selectedPageSize);
          }
        });
      } else {
        this.selectedPageSize = value;
        if (initComplete) {
          this.pageSizeChange.emit(this.selectedPageSize);
        }
      }
    }
  }
  @Output() pageSizeChange: EventEmitter<number> = new EventEmitter();

  public selectedPageSize: number;

  public pagingSizeItems = new Array<SelectItem>();

  constructor(private _translationService: TranslationService) {}

  async ngOnInit() {
    const sizes = new Array<SelectItem>();
    const showVal = await this._translationService.getTitlecase('common.page-size.show');
    const showAll = await this._translationService.getTitlecase('common.page-size.show-all');

    this.pageSizes.forEach((x) => {
      if (+x > 0) {
        sizes.push({
          label: showVal + x.toString(),
          value: +x,
        });
      } else if (+x === 0) {
        sizes.push({
          label: showAll,
          value: 99999,
        });
      }
    });

    this.pagingSizeItems = sizes;
  }
}
